<template>
  <div class="contact">
    <div class="contentInfo" v-loading="loading">
      <div class="contact">
        <div class="form">
          <div class="title">Request for eQuote account</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" @keyup.native="keyup" placeholder="Please enter First Name" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" @keyup.native="keyup" placeholder="Please enter Last Name" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" @keyup.native="keyup" placeholder="Please enter Email" />
            </el-form-item>
            <el-form-item label="Company Name" prop="companyName">
              <el-input v-model="ruleForm.companyName" @keyup.native="keyup" placeholder="Please enter Company Name" />
            </el-form-item>
            <el-form-item label="Job Title" prop="position">
              <el-input v-model="ruleForm.position" @keyup.native="keyup" placeholder="Please enter Job Title" />
            </el-form-item>
            <el-form-item label="Office Location" prop="location">
              <el-input v-model="ruleForm.location" @keyup.native="keyup" placeholder="Please enter Office Location" />
            </el-form-item>
            <el-form-item label="Phone Number" prop="mobile">
              <el-input v-model="ruleForm.mobile" @keyup.native="keyup" placeholder="Please enter Phone Number" />
            </el-form-item>
            <el-form-item prop="check" style="width:100%">
              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;" class="checkyes">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

          <div class="flexCenter">
            <div class="button" @click="submitForm('ruleForm')">
              Register
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible="dialogVisible" width="30%">
      <span style="word-break:break-word">Thank you for registering with equote. We will send your user name and password to your email after we review it</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false;$router.push('/')">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  mail: "",
  firstname: "",
  lastname: "",
  mobile: "",
  position: "", //所属职位
  companyName: "", //公司名称
  location: "",
  check: true
};
import { editConsultMail, advertisementFlow, editContactUs } from "@/api/api";
export default {
  name: "Contact",
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      checkList: [],
      interested: "",
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      showTip: false,
      tipStatus: true,
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        companyName: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        location: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        position: [{ required: true, message: "Please complete this required field", trigger: "blur" }],

        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      loading: false
    };
  },
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "register",
          source: "",
          information: "注册页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "register",
          source: this.$route.query.source,
          information: "注册页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    change() {
      this.interested = this.checkList.join();
      console.log(this.interested);
    },
    keyup() {
      this.$refs["ruleForm"].clearValidate();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.ruleForm.fullName = this.ruleForm.firstname + " " + this.ruleForm.lastname;
          let ruleForm = {
            firstName: this.ruleForm.firstname,
            lastName: this.ruleForm.lastname,
            fullName: this.ruleForm.fullName,
            mail: this.ruleForm.mail,
            mobile: this.ruleForm.mobile,
            position: this.ruleForm.position,
            address: this.ruleForm.location,
            companyName: this.ruleForm.companyName
          };
          this.checkList = [];
          editContactUs(ruleForm).then(res => {
            if (res.code == 10000) {
              this.showTip = true;
              this.tipStatus = true;
              this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
              this.loading = false;
              this.dialogVisible = true;
            } else {
              this.loading = false;
              this.showTip = true;
              this.tipStatus = false;
            }
          });
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.check {
  margin-right: 10px;
}
.marginTop30 {
  margin-top: 0.3rem;
}
.fontBold {
  font-weight: bold;
}
.title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 30px;
}
.contentInfo {
  background: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/Register.jpg") no-repeat center top;
  background-size: 100% 100%;
  width: 100%;
  padding: 100px 0 75px;
  .contact {
    padding: 60px 63px;
    width: 888px;
    margin: 0 auto;
    background: #fff;
    .form {
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        /deep/ .el-form-item {
          display: inline-block;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          &:nth-child(even) {
            .el-form-item__label {
              margin-left: 7px;
            }
          }
          &:not(.text) {
            width: 50%;
          }
          &.text {
            width: 100%;
          }
          .el-form-item__content {
            flex: 1;
            .el-input {
              width: 238px !important;
            }
          }

          .el-form-item__label {
            width: 133px;
            font-size: 15px;
            display: block;
            font-weight: normal;
          }
          .el-textarea__inner {
            min-height: 104px !important;
          }
          .el-input__inner,
          .el-textarea__inner {
            // width: 250px;
            background: #fafafa;
            border: 1px solid #e6e6e6;
            border-radius: 7px;
            font-size: 15px;
          }
          .el-textarea__inner {
            width: 500px;
          }
          .el-form-item__error {
            font-size: 12px !important;
          }
        }
      }
      .button {
        margin-top: 17px;
        background: #217df6;
        font-size: 13px;
        color: #fff;
        border-radius: 7px;
        text-align: center;
        width: 91px;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .checkyes {
    font-size: 60px;
  }
  .type {
    font-size: 70px;
  }
  .check {
    width: 100px;
    height: 100px;
  }
  .title {
    font-size: 70px;
  }
  .contentInfo {
    .contact {
      width: 90%;
      .form {
        .el-form {
          /deep/ .el-form-item {
            &:not(.text) {
              width: 100%;
            }
            .el-form-item__content {
              flex: 1;
              .el-input {
                width: 100% !important;
                margin-bottom: 30px;
              }
            }
            .el-form-item__label {
              // width: 400px;
              width: 100%;
              text-align: left;
              line-height: 100px;
              font-size: 70px !important;
            }
            .el-form-item__label::before {
              position: static;
            }
            .el-input__inner {
              width: 1000px;
              height: 100px;
              font-size: 60px !important;
            }
            .el-textarea__inner {
              width: 1000px;
              height: 300px;
              font-size: 60px !important;
            }
            .el-form-item__error {
              top: 100px;
              font-size: 40px !important;
            }
            .type {
              line-height: 70px;
            }
            .el-checkbox-group {
              font-size: 40px;
              .el-checkbox {
                margin: 10px;
              }
              .el-checkbox__input {
                .el-checkbox__inner {
                  width: 80px;
                  height: 80px;
                }
                .el-checkbox__label {
                  font-size: 70px !important;
                }
              }
            }
          }
        }
        .button {
          width: 350px;
          height: 100px;
          font-size: 70px;

          padding: 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 576px) {
  .el-dialog {
    padding: 100px;
    width: 90% !important;
    // height: 1000px;
    font-size: 100px;
    .el-dialog__body {
      text-align: center;
      padding: 100px;
      font-size: 50px;
      word-break: break-word;
    }
    .el-button--default,
    .el-button--primary {
      padding: 50px 70px;
      font-size: 50px;
    }
  }
  .el-checkbox {
    font-size: 70px !important;
    .el-checkbox__label {
      font-size: 70px;
    }
  }
}
</style>
